module.exports = "<div class=\"panel panel-default\" ng-class=$ctrl.class> <div class=panel-heading ng-if=$ctrl.titulo> <i class=\"fa {{ $ctrl.icone || 'fa-list-alt' }} text-muted\"></i> {{ $ctrl.titulo }} <span class=pull-right style=color:#aeaeae>{{ $ctrl.subtitulo }}</span> </div> <div class=panel-body ng-transclude></div> </div>";


//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/components/painel/painel-component-template.html
// module id = 280
// module chunks = 1